export const dislikeImg = require("../../../assets/media/articles/dislike-circle.png");
export const likeImg = require("../../../assets/media/articles/like-circle.png");



// WEBPACK FOOTER //
// ./src/screens/Articles/constants/assets.js